import request from '@/utils/request'

// 获取账户列表
export async function getList(params) {
	return request({
		url: '/rest/writeoff/page',
		method: 'get',
		params,
	})
}

// 获取店铺列表
export async function getShops(params) {
	return request({
		url: '/rest/finance/store/page',
		method: 'get',
		params,
	})
}

// 获取店铺列表 - 新
export async function getShops2(params) {
	return request({
		url: '/rest/store/queryStoreList',
		method: 'get',
		params,
	})
}
// 添加
export async function add(data) {
	return request({
		url: '/rest/writeoff/add',
		method: 'post',
		headers: {
			'Content-Type': "application/json;charset=UTF-8"
		},
		data,
	})
}
// 修改
export async function update(data) {
	return request({
		url: '/rest/writeoff/update',
		method: 'post',
		headers: {
			'Content-Type': "application/json;charset=UTF-8"
		},
		data,
	})
}
// 删除banner
export async function del(data) {
	return request({
		url: '/rest/writeoff/delete',
		method: 'post',
		headers: {
			'Content-Type': "application/json;charset=UTF-8"
		},
		data,
	})
}